import img1 from "../images/sponsor/1.png";
import img2 from "../images/sponsor/2.png";
import img3 from "../images/sponsor/3.png";
import img4 from "../images/sponsor/4.png";
import img5 from "../images/sponsor/5.png";
import img6 from "../images/sponsor/6.png";
import img7 from "../images/sponsor/7.png";
import img8 from "../images/sponsor/8.png";
const sponsors = [
	{
		img: img1,
	},
	{
		img: img2,
	},
	{
		img: img3,
	},
	{
		img: img4,
	},
];
const co_sponsors = [
	{
		img: img5,
	},
	{
		img: img6,
	},
	{
		img: img7,
	},
	{
		img: img8,
	},
];
export { co_sponsors };
export default sponsors;
